import React from 'react';

import SwatchDeepLink from './swatch-deep-link';
import SwatchFilter from './swatch-filter';
import ProductPrice from '../../../product/components/product-price';
import PurchaseButtonValidator from '../../../product/components/validate-purchase-btn';
import BundleModule from '../bundle/bundle-module';
import CarePackModule from '../bundle/carepack-module';
import { buildSwatches } from './swatch-functions';

import '../../css/variant-swatch.less';

class VariantSwatch extends React.PureComponent {

	state ={
		swatches: [],
		selectedSwatches: {},
		filteredSkus:[],
		disabledSkus: null,
		defaultSku: null,
		prdMap: [],
		pricesFetched: false,
		productOffline: false
	}

	static getDerivedStateFromProps(props, state) {
		const { variantSkus=[] } = props;
		const [ firstVariant ] = variantSkus;
		const { defaultSku } = state; 
	    if (defaultSku !== firstVariant) {
	      return {
	        defaultSku: firstVariant,
	      };
	    }

	    // Return null if the state hasn't changed
	    return null;
	 }

	componentDidUpdate(prevProps, prevState){
		this.findDisabledSkus(this.props.prices);	
	}

    //separate check for disabled skus, it is waiting for HpServices to resolve
	findDisabledSkus = (prices) => {
		const { variantSkus, fetchedProducts } = this.props;
		let oosCount = 0;

		let newDisabledSkus = variantSkus.filter((sku)=>{
			//if variant product doesn't have a record in hpServices or product is inactive
			if(!fetchedProducts[sku].active || !prices.hasOwnProperty(sku)){
				return true;
			}
			//if variant product is OOS
			else if(prices[sku] && prices[sku].stock === 0){
				oosCount++;
				return true;
			}
			return false;
		})

		if(!this.state.disabledSkus || newDisabledSkus.toString() !== this.state.disabledSkus.toString()){
			this.setNewSwatchState(newDisabledSkus, true, oosCount);
		}
	}

	setNewSwatchState = (disabledSkus, pricesFetched=false, oosCount) => {
		//pricesFetched is a variable that controls ProductPrice rendering, to prevent price fetching
		//getting a defaultSku
		const { variantSkus } = this.props
		var defaultSku = variantSkus.find(function(sku) {
		  return !disabledSkus.includes(sku);
		});

		//if no products are oos and can't match a default sku, product is disabled
		const productOffline = oosCount == 0 && !defaultSku;
		if(productOffline){
			//if product is offline just default to first sku to trigger strikethrough affect
			defaultSku = variantSkus[0]
		}

		//setting a new swatch state
		const newSwatchState = Object.assign({disabledSkus, defaultSku, pricesFetched, productOffline},
			buildSwatches(this.props.product.variants, disabledSkus));
		this.handleChange(newSwatchState);
	}



	selectSwatch = (sGKey, swatch, groupLevel) => {
		var selectedSwatches = Object.assign({},this.state.selectedSwatches, {[sGKey]: swatch});
		var filteredSkus = this.filterSkus(selectedSwatches);
		if(filteredSkus.length < 1 || this.state.disabledSkus.includes(filteredSkus[0])){
			selectedSwatches = Object.keys(selectedSwatches).reduce((newSelectedSwatches,key)=>{
				if(selectedSwatches[key].groupLevel <= groupLevel){
					newSelectedSwatches[key] = selectedSwatches[key];
				}
				return newSelectedSwatches;
			},{});
			//Preselecting any product weather it's OOS or not
			const availableSku = this.filterSkus(selectedSwatches)[0];
			const prdRecord = this.state.prdMap.filter(prd=>prd.sku === availableSku)[0];
			this.state.swatches.forEach((swatchGroup)=>{
				if(!selectedSwatches.hasOwnProperty(swatchGroup.key)){
					const targetValue = prdRecord[swatchGroup.key];
					selectedSwatches[swatchGroup.key] = swatchGroup.values.filter(swatch => swatch.value === targetValue)[0];
				}
			});
			filteredSkus = [availableSku];
		}
		this.handleChange({selectedSwatches, filteredSkus});
		this.validate(true, selectedSwatches);
		this.updateProduct(selectedSwatches, filteredSkus);
	}

	//passing Variant product to update product's data
	updateProduct = (selectedSwatches, filteredSkus) => {
		const validated = this.validate(false, selectedSwatches);
		const variantPrd = this.props.fetchedProducts[filteredSkus[0]];
		if(variantPrd && variantPrd.sku !== this.props.product.sku && validated){
			this.props.modifyProductWithVariant(variantPrd);
		}
	}

	filterSkus = (selectedSwatches) => {
		const filteredSkus = this.state.prdMap.reduce((arr, prd)=>{
			let match = true;
			Object.keys(selectedSwatches).forEach((key)=>{
				if(selectedSwatches[key].value !== prd[key]){
					match = false;
				}
			})
			if(match) arr.push(prd.sku);
			return arr;
		},[]);
		return filteredSkus;
	}

	selectProduct = (selectedSwatches) => {
		const filteredSkus = this.filterSkus(selectedSwatches);
		this.handleChange({selectedSwatches, filteredSkus, productOffline: false});
		this.updateProduct(selectedSwatches, filteredSkus);
	}

	handleChange = (stateSlice) => {
		this.setState(stateSlice);
	};

	validate = (updateValidator, selectedSwatches=this.state.selectedSwatches) => {
		const { swatches } = this.state;
		for(let i=0;i<swatches.length;i++){
			const groupName = swatches[i].key;
			if(!selectedSwatches.hasOwnProperty(groupName)){
				updateValidator && this.props.validationContext.data.isValid !== false && this.props.validationContext.control.updateValidation({
					errMsg: `Select a ${swatches[i].displayName.toLowerCase()} to continue`,
					isValid: false,
				});
				return false;
			}
		};
		updateValidator && this.props.validationContext.control.updateValidation({
			errMsg: null,
			isValid: true,
		});
		return true;
	}

	render(){
		const {
			swatches,
			selectedSwatches,
			disabledSkus,
			defaultSku,
			pricesFetched
		} = this.state;
		const { product, purchaseButton, onAddOnChange, totalPrice, fetchedProducts, showCarepackModule, carePacks } = this.props;
		const { eol, pdpConfig={} } = product;
		const { pdpCarepackModule } = pdpConfig;
		const hasBundle = !eol && !!product.bundle;
		const shippingText = !product.eol && 'Ships within 1 business day';
		
		return (
			<div className='variant-swatch'>
				<SwatchDeepLink
					selectProduct={this.selectProduct}
					swatches={swatches}
					selectedSwatches={selectedSwatches}
					disabledSkus={disabledSkus}
					defaultSku={defaultSku}
					variantsFetched={Object.keys(fetchedProducts).length > 0}
				/>
				<SwatchFilter
					swatchGroups={swatches}
					selectSwatch={this.selectSwatch}
					selectedSwatches={selectedSwatches}
					disabledSkus={disabledSkus}
				/>
				{	hasBundle ? 
					<BundleModule 
					productSku={product.sku} 
					productsList={product.bundle.productsList} 
					metaData={product.bundle.metaData} 
					onChange={onAddOnChange}
					/> 
					: showCarepackModule && 
						<CarePackModule 
							product={product} 
							carePacks={carePacks} 
							onChange={onAddOnChange} 
							template='default'
							customConfig={pdpCarepackModule}
						/>
				}
				{/* Hacky check to make sure child sku is selected before showing price*/}
				{pricesFetched && product.sku.indexOf('P_') < 0 && <ProductPrice product={product} totalPrice={totalPrice} className={`${totalPrice ? 'total-price' : ''}${!hasBundle ? ' non-bundle-price' : ''}`}/>}
				<PurchaseButtonValidator
					showSelector={true}
					showSelectorHeader={true}
					product={product}
					shippingText={shippingText}
					purchaseButton={purchaseButton}
					className='swatch-pb-validator'
				/>
			</div>
		)
	}
}

VariantSwatch.whyDidYouRender = true;

export { VariantSwatch };
export default VariantSwatch;
